import approveProcessingInboxReducer from "./approveProcessingInboxReducer";

const approveProcessingReducers = {
    approveProcessingInbox: approveProcessingInboxReducer,
}
export default approveProcessingReducers;